import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function DeleteHistoricalConfirmModal({ confirm, show, close }){

  return (
    <Modal show={ show } onHide={ close } >

      <Modal.Header closeButton>
        <Modal.Title>Confirm deletion</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <h3>Are you sure you want to delete your History?</h3>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={ close }>Cancel</Button>
        <Button onClick={ confirm } bsStyle="danger">Delete</Button>
      </Modal.Footer>

    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/Settings/QRcodes/DeleteHistoricalConfirmModal.js